define.alias("shared/components/shared/ui/calculating-state", "preview-grid/components/shared/ui/calculating-state");